import axios from "../axiosPlugin.js";

export const getUserList = (data, loading = true) => {
  return axios({
    url: "/api/account/list",
    method: 'get',
    data: {
      data,
      loading
    },
  })
}

export const createUser = (data, loading = true) => {
  return axios({
    url: "/api/account/create",
    method: 'post',
    data: {
      data,
      loading
    },
  })
}

export const updateUser = (data, loading = true) => {
  return axios({
    url: "/api/account/update",
    method: 'put',
    data: {
      data,
      loading
    },
  })
}

export const getUserDetail = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/account/detail/" + data.id,
    method: 'get',
    data: {
      data: {},
      loading,
      isDefaultAlertTips,
    },
  })
}

export const deleteUser = (data, loading = true) => {
  return axios({
    url: "/api/account/delete/" + data.id,
    method: 'delete',
    data: {
      data: {},
      loading
    },
  })
}

export const updateUserStatus = (data, loading = true) => {
  return axios({
    url: "/api/updateStatus?" + data,
    method: 'post',
    data: {
      data,
      loading
    },
  })
}

export const updatePasswordService = (data, loading = true) => {
  return axios({
    url: "/api/updatePassword",
    method: "post",
    data: {
      data,
      loading
    }
  });
};
